import React from "react";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";
import { cn } from "../lib/helpers";
import Icon from "./icon";
import { Link } from "gatsby";
import { getNewsUrl } from "../lib/helpers";

import * as styles from "../styles/components/news-card.module.css";

const NewsCard = (props) => {

  const {
    news,
    title
  } = props;

  return (
    <div className={styles.root}>
      <Link className={styles.link} to={getNewsUrl(news.category, news.slug)}>
        {news.featuredImage && news.featuredImage.asset && 
          <div className={styles.image}>
            <img
              src={imageUrlFor(buildImageObj(news.featuredImage))
                .auto("format")
                .url()}
              alt={news.featuredImage.alt}
            />
          </div>
        }
        <div className={styles.text}>
          {news.category && news.category.title && <div className={styles.category}>{news.category.title}</div>}
          {news.pageHeader.title && 
            <>
              {title
                ? <h2 className={cn("h5", styles.title)}>{news.pageHeader.title}</h2>
                : <h3 className={cn("h5", styles.title)}>{news.pageHeader.title}</h3>
              }
            </>
          }
        </div>
        <span className={styles.linkIcon}><Icon symbol="more" /></span>
      </Link>
    </div>
  );
}

export default NewsCard;
